/**
 * Naive `YYYY-MM-DDTHH:mm` is interpreted as Asia/Ulaanbaatar wall time (UTC+8).
 */
export function parseNaiveUlaanbaatarToUnixMs(raw) {
  const m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/.exec(String(raw ?? "").trim());
  if (!m) {
    return null;
  }
  const y = Number(m[1]);
  const mo = Number(m[2]);
  const d = Number(m[3]);
  const h = Number(m[4]);
  const mi = Number(m[5]);
  const pad = (n) => String(n).padStart(2, "0");
  const iso = `${pad(y)}-${pad(mo)}-${pad(d)}T${pad(h)}:${pad(mi)}:00+08:00`;
  const ms = Date.parse(iso);
  return Number.isNaN(ms) ? null : ms;
}

export function getExamEntryWindowUnixMs(test_dt, testMinutes) {
  const startMs = parseNaiveUlaanbaatarToUnixMs(test_dt);
  if (startMs === null) {
    return null;
  }
  const hideAfterMs = getNextUlaanbaatarMidnightUnixMs(startMs);
  if (hideAfterMs === null) {
    return null;
  }
  return {
    openMs: startMs,
    closeMs: hideAfterMs
  };
}

/** Whether `nowMs` is inside [test_dt, next day 00:00 UB). */
export function isExamEntryOpen(test_dt, testMinutes, nowMs = Date.now()) {
  const w = getExamEntryWindowUnixMs(test_dt, testMinutes);
  if (!w) {
    return false;
  }
  return nowMs >= w.openMs && nowMs < w.closeMs;
}

/** Today's calendar date in Asia/Ulaanbaatar as `YYYY-MM-DD`. */
export function getTodayYmdUlaanbaatar(nowMs = Date.now()) {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Ulaanbaatar",
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).formatToParts(new Date(nowMs));
  const y = parts.find((p) => p.type === "year")?.value;
  const mo = parts.find((p) => p.type === "month")?.value;
  const d = parts.find((p) => p.type === "day")?.value;
  if (!y || !mo || !d) {
    return "";
  }
  return `${y}-${mo}-${d}`;
}

/** Next UB midnight (start of next day) for a given unix ms timestamp. */
export function getNextUlaanbaatarMidnightUnixMs(unixMs) {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Ulaanbaatar",
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).formatToParts(new Date(unixMs));
  const y = parts.find((p) => p.type === "year")?.value;
  const mo = parts.find((p) => p.type === "month")?.value;
  const d = parts.find((p) => p.type === "day")?.value;
  if (!y || !mo || !d) {
    return null;
  }
  const asUtcMidnight = Date.parse(`${y}-${mo}-${d}T00:00:00+08:00`);
  if (Number.isNaN(asUtcMidnight)) {
    return null;
  }
  return asUtcMidnight + 24 * 60 * 60 * 1000;
}

/**
 * List UI visibility: EXAM row is shown from exact start time
 * until 00:00 of the next UB calendar day.
 */
export function shouldShowExamInMockList(test_dt, nowMs = Date.now()) {
  const startMs = parseNaiveUlaanbaatarToUnixMs(test_dt);
  if (startMs === null) {
    return false;
  }
  const openMs = startMs;
  const hideAfterMs = getNextUlaanbaatarMidnightUnixMs(startMs);
  if (hideAfterMs === null) {
    return false;
  }
  return nowMs >= openMs && nowMs < hideAfterMs;
}
